module.exports = __webpack_public_path__ + "static/media/Logo_Susu_Tango.115bdcd3.png";